import React from "react";
import {SvgIcon, SvgIconProps} from "@material-ui/core";


const PencilIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <svg version="1.1" id="Layer_1"  x="0px" y="0px" viewBox="0 0 512 512">
                <g>
                    <g>
                        <path d="M449.082,416.085"/>
                        <path d="M451.155,45.394c-28.165-27.724-73.824-27.724-101.989,0L63.24,326.846
			c-1.955,1.926-3.372,4.32-4.111,6.943L21.529,467.41c-1.549,5.478,0.026,11.34,4.107,15.37c4.087,4.017,10.047,5.56,15.614,4.049
			l135.738-37.017c2.67-0.728,5.097-2.123,7.059-4.053l285.918-281.454c28.121-27.743,28.121-72.657,0-100.4L451.155,45.394z
			 M98.162,337.097l234.003-230.351l75.468,74.287L173.622,411.388L98.162,337.097z M83.085,366.874l60.292,59.36L59.98,448.979
			L83.085,366.874z M447.298,141.999l-16.993,16.728l-75.48-74.294L371.832,67.7c15.646-15.395,41.009-15.395,56.655,0l18.811,18.51
			C462.921,101.631,462.921,126.584,447.298,141.999L447.298,141.999z M447.298,141.999"/>
                    </g>
                </g>
            </svg>
        </SvgIcon>
    )
};

export default PencilIcon;